import locomotiveScroll from "locomotive-scroll"
import 'locomotive-scroll/dist/locomotive-scroll.css'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.provide('locomotiveScroll', locomotiveScroll)
})
